export default __webpack_public_path__ + "static/media/day2.3d3db5f6.png";